import { ThunkAction, ThunkDispatch } from "redux-thunk";
import Prefix from 'src/helpers/ApiPrefix';
import AXIOS from 'src/helpers/Axios';
import Headers from 'src/helpers/Headers';
import { supplierAction } from "src/reducers/supplierReducer";
import { scheduleJobActionTypes, shortCodeActionTypes, staticRedirectActionTypes, supplierActionTypes, systemLogActionTypes } from "src/types/actionTypes";
import { Supplier, SupplierList } from "src/types/supplierTypes";
import { ErrorAction, SuccessAction } from "src/types/responseTypes";
import { StaticRedirect, StaticRedirectList } from "src/types/staticRedirectTypes";
import { ShortCodeList } from "src/types/shortCodeTypes";
import { SystemLogList } from "src/types/systemLogTypes";
import { ScheduleJob, ScheduleJobList } from "src/types/scheduleJobTypes";

export const SupplierFailure = (message: string): ErrorAction => {
    return {
        type: supplierActionTypes.SUPPLIER_FAILURE,
        payload: { message: message }
    }
}
export const SupplierSuccess = (payload: SupplierList): SuccessAction<SupplierList> => {
    return {
        type: supplierActionTypes.FETCH_SUPPLIER_SUCCESS,
        payload: payload,
    }
}
export const SupplierAllSuccess = (payload: SupplierList): SuccessAction<SupplierList> => {
    return {
        type: supplierActionTypes.FETCH_SUPPLIER_ALL_SUCCESS,
        payload: payload,
    }
}

export const SupplierAddSuccess = (payload: Supplier): SuccessAction<Supplier> => {
    return {
        type: supplierActionTypes.ADD_SUPPLIER_SUCCESS,
        payload: payload,
    }
}
export const SupplierSingleSuccess = (payload: Supplier): SuccessAction<Supplier> => {
    return {
        type: supplierActionTypes.FETCH_SINGLE_SUPPLIER_SUCCESS,
        payload: payload,
    }
}

export const StaticRedirectSuccess = (payload: StaticRedirectList): SuccessAction<StaticRedirectList> => {
    return {
        type: staticRedirectActionTypes.FETCH_STATIC_REDIRECT_SUCCESS,
        payload: payload,
    }
}

export const ShortCodeSuccess = (payload: ShortCodeList): SuccessAction<ShortCodeList> => {
    return {
        type: shortCodeActionTypes.FETCH_SHORTCODE_SUCCESS,
        payload: payload,
    }
}

export const SystemLogSuccess = ( payload: SystemLogList): SuccessAction<SystemLogList> => {
    return {
        type: systemLogActionTypes.FETCH_SYSTEM_LOG_SUCCESS,
        payload: payload,
    }
}


export const ScheduleJobAddSuccess = (payload: ScheduleJob): SuccessAction<ScheduleJob> => {
    return {
        type: scheduleJobActionTypes.SCHEDULE_JOB_ADD_SUCCESS,
        payload: payload,
    }
}

export const ScheduleJobUpdateSuccess = (payload: any): SuccessAction<any> => {
    return {
        type: scheduleJobActionTypes.SCHEDULE_JOB_UPDATE_SUCCESS,
        payload: payload,
    }
}

export const ScheduleJobDeleteSuccess = (payload: any): SuccessAction<any> => {
    return {
        type: scheduleJobActionTypes.SCHEDULE_JOB_DELETE_SUCCESS,
        payload: payload,
    }
}

export const ScheduleJobFailure = (message: string): ErrorAction => {
    return {
        type: scheduleJobActionTypes.SCHEDULE_JOB_FAILURE,
        payload: { message: message }
    }
}

export const ScheduleJobSuccess = ( payload: ScheduleJobList): SuccessAction<ScheduleJobList> => {
    return {
        type: scheduleJobActionTypes.FETCH_SCHEDULE_JOB_SUCCESS,
        payload: payload,
    }
}




export const SupplierUpdateSuccess = (payload: any): SuccessAction<any> => {
    return {
        type: supplierActionTypes.UPDATE_SUPPLIER_SUCCESS,
        payload: payload,
    }
}


export const SupplierDeleteSuccess = (payload: any): SuccessAction<any> => {
    return {
        type: supplierActionTypes.DELETE_SUPPLIER_SUCCESS,
        payload: payload,
    }
}


export const StaticRedirectFailure = (payload: any): SuccessAction<any> => {
    return {
        type: staticRedirectActionTypes.STATIC_REDIRECT_FAILURE,
        payload: payload,
    }
}




export const SupplierAllRequest = (filter: any, search: string, pageNo: number, limit: number, status: boolean):
    ThunkAction<Promise<void>, {}, {}, supplierAction> => {
    return (dispatch: ThunkDispatch<{}, {}, supplierAction>) => {
        return AXIOS.post(`${Prefix.api}/admin/suppliers`, { filter, search, pageNo, limit, status }, { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const suppliers: SupplierList = data.result
                dispatch(SupplierSuccess(suppliers))

            }
        }).catch((e) => {
            if (e.response) {
                dispatch(SupplierFailure(e.response.data.message));
            }
            else {
                dispatch(SupplierFailure(e.message));
            }
        })
    }
}

export const SupplierAllRequestData = ():
    ThunkAction<Promise<void>, {}, {}, supplierAction> => {
    return (dispatch: ThunkDispatch<{}, {}, supplierAction>) => {
        return AXIOS.get(`${Prefix.api}/admin/suppliers/all`, { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const suppliers: SupplierList = data.result
                dispatch(SupplierAllSuccess(suppliers))
            }
        }).catch((e) => {
            if (e.response) {
                dispatch(SupplierFailure(e.response.data.message));
            }
            else {
                dispatch(SupplierFailure(e.message));
            }
        })
    }
}




export const SupplierAddRequest = (supplier: Supplier, setMessageHandler: any, setSubmitting: any):
    ThunkAction<Promise<void>, {}, {}, supplierAction> => {
    setMessageHandler({
        hasMessage: false,
        type: '',
        message: '',
    });
    return (dispatch: ThunkDispatch<{}, {}, supplierAction>) => {
        return AXIOS.post(`${Prefix.api}/admin/supplier/add`, supplier, { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const supplier: Supplier = data.result;
                dispatch(SupplierAddSuccess(supplier))
                setSubmitting(false);
                setMessageHandler({
                    hasMessage: true,
                    type: 'success',
                    message: data.message,
                });
            }
        }).catch((e) => {
            if (e.response) {
                setSubmitting(false);
                dispatch(SupplierFailure(e.response.data.message));
                setMessageHandler({
                    hasMessage: true,
                    type: 'error',
                    message: e.response.data.message,
                });
            }
            else {
                setSubmitting(false);
                dispatch(SupplierFailure(e.message));
                setMessageHandler({
                    hasMessage: true,
                    type: 'error',
                    message: e.message,
                });
            }
        })
    }
}


export const SupplierUpdateRequest = (catid: string, supplier: Supplier, setMessageHandler: any, setSubmitting: any):
    ThunkAction<Promise<void>, {}, {}, supplierAction> => {
    setMessageHandler({
        hasMessage: false,
        type: '',
        message: '',
    });
    return (dispatch: ThunkDispatch<{}, {}, supplierAction>) => {
        return AXIOS.put(`${Prefix.api}/admin/supplier/update/${catid}`, supplier, { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const supplier: Supplier = data.result;
                dispatch(SupplierUpdateSuccess(supplier))
                setSubmitting(false);
                setMessageHandler({
                    hasMessage: true,
                    type: 'success',
                    message: data.message,
                });
            }
        }).catch((e) => {
            if (e.response) {
                setSubmitting(false);
                setMessageHandler({
                    hasMessage: true,
                    type: 'error',
                    message: e.response.data.message,
                });
                dispatch(SupplierFailure(e.response.data.message));
            }
            else {
                setSubmitting(false);
                setMessageHandler({
                    hasMessage: true,
                    type: 'error',
                    message: e.message,
                });
                dispatch(SupplierFailure(e.message));
            }
        })
    }
}

export const SupplierStatusUpdateRequest = (supplierid: string, supplier: Supplier, setMessageHandler: any):
    ThunkAction<Promise<void>, {}, {}, supplierAction> => {
    setMessageHandler({
        hasMessage: false,
        type: '',
        message: '',
    });
    return (dispatch: ThunkDispatch<{}, {}, supplierAction>) => {
        return AXIOS.put(`${Prefix.api}/admin/supplier/update/${supplierid}`, supplier, { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const supplier: Supplier = data.result;
                dispatch(SupplierUpdateSuccess(supplier))
                setMessageHandler({
                    hasMessage: true,
                    type: 'success',
                    message: data.message,
                });
            }
        }).catch((e) => {
            if (e.response) {
                setMessageHandler({
                    hasMessage: true,
                    type: 'error',
                    message: e.response.data.message,
                });
                dispatch(SupplierFailure(e.response.data.message));
            }
            else {
                setMessageHandler({
                    hasMessage: true,
                    type: 'error',
                    message: e.message,
                });
                dispatch(SupplierFailure(e.message));
            }
        })
    }
}


export const SupplierSingleRequest = (catid: string,body:any):
    ThunkAction<Promise<void>, {}, {}, supplierAction> => {
    return (dispatch: ThunkDispatch<{}, {}, supplierAction>) => {
        return AXIOS.post(`${Prefix.api}/admin/supplier/${catid}`,body, { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const supplier: Supplier = data.result;
                dispatch(SupplierSingleSuccess(supplier));
            }
        }).catch((e) => {
            if (e.response) {
                dispatch(SupplierFailure(e.response.data.message));
            }
            else {
                dispatch(SupplierFailure(e.message));
            }
        })
    }
}


export const SupplierDeleteRequest = (id: string, body: Supplier, setMessageHandler: any):
    ThunkAction<Promise<void>, {}, {}, supplierAction> => {
    setMessageHandler({
        hasMessage: false,
        type: '',
        message: '',
    });
    return (dispatch: ThunkDispatch<{}, {}, supplierAction>) => {
        return AXIOS.put(`${Prefix.api}/admin/supplier/update/${id}`, body, { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const supplier: Supplier = data.result;
                dispatch(SupplierDeleteSuccess(supplier))
                setMessageHandler({
                    hasMessage: true,
                    type: 'success',
                    message: data.message,
                });
            }
        }).catch((e) => {
            if (e.response) {
                dispatch(SupplierFailure(e.response.data.message));
                setMessageHandler({
                    hasMessage: true,
                    type: 'error',
                    message: e.response.data.message,
                });
            }
            else {
                dispatch(SupplierFailure(e.message));
                setMessageHandler({
                    hasMessage: true,
                    type: 'error',
                    message: e.message,
                });
            }
        })
    }
}



export const StaticRedirectsRequest = ():
    ThunkAction<Promise<void>, {}, {}, supplierAction> => {
    return (dispatch: ThunkDispatch<{}, {}, supplierAction>) => {
        return AXIOS.get(`${Prefix.api}/admin/static/redirects`, { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const supplier: StaticRedirectList = data.result;
                dispatch(StaticRedirectSuccess(supplier));
            }
        }).catch((e) => {
            if (e.response) {
                dispatch(StaticRedirectFailure(e.response.data.message));
            }
            else {
                dispatch(StaticRedirectFailure(e.message));
            }
        })
    }
}

export const ShortCodeRequest = (filter:any):
    ThunkAction<Promise<void>, {}, {}, supplierAction> => {
    return (dispatch: ThunkDispatch<{}, {}, supplierAction>) => {
        return AXIOS.post(`${Prefix.api}/admin/shortcode`,{ filter },  { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const supplier: ShortCodeList = data.result;
                dispatch(ShortCodeSuccess(supplier));
            }
        }).catch((e) => {
            if (e.response) {
                dispatch(StaticRedirectFailure(e.response.data.message));
            }
            else {
                dispatch(StaticRedirectFailure(e.message));
            }
        })
    }
}



export const SystemLogRequest = (filter:any):
    ThunkAction<Promise<void>, {}, {}, supplierAction> => {
    return (dispatch: ThunkDispatch<{}, {}, supplierAction>) => {
        dispatch({ type:systemLogActionTypes.SYSTEM_LOG_REQUEST,payload: { loading:true} });
        return AXIOS.post(`${Prefix.api}/admin/system/log`,{ filter },  { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const supplier: SystemLogList = data.result;
                dispatch(SystemLogSuccess(supplier));
            }
        }).catch((e) => {
            if (e.response) {
                dispatch(StaticRedirectFailure(e.response.data.message));
            }
            else {
                dispatch(StaticRedirectFailure(e.message));
            }
        })
    }
}

export const ScheduleJobRequest = (filter:any):
    ThunkAction<Promise<void>, {}, {}, supplierAction> => {
    return (dispatch: ThunkDispatch<{}, {}, supplierAction>) => {
        dispatch({ type:scheduleJobActionTypes.SCHEDULE_JOB_REQUEST,payload: { loading:true} });
        return AXIOS.post(`${Prefix.api}/admin/schedule/jobs`,{ filter },  { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const supplier: ScheduleJobList = data.result;
                dispatch(ScheduleJobSuccess(supplier));
            }
        }).catch((e) => {
            if (e.response) {
                dispatch(StaticRedirectFailure(e.response.data.message));
            }
            else {
                dispatch(StaticRedirectFailure(e.message));
            }
        })
    }
}



export const ScheduleJobAddRequest = (scheduleJob: ScheduleJob, setMessageHandler: any, setSubmitting: any):
    ThunkAction<Promise<void>, {}, {}, supplierAction> => {
    setMessageHandler({
        hasMessage: false,
        type: '',
        message: '',
    });
    return (dispatch: ThunkDispatch<{}, {}, supplierAction>) => {
        return AXIOS.post(`${Prefix.api}/admin/schedule/job/add`, scheduleJob, { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const supplier: ScheduleJob = data.result;
                dispatch(ScheduleJobAddSuccess(supplier))
                setSubmitting(false);
                setMessageHandler({
                    hasMessage: true,
                    type: 'success',
                    message: data.message,
                });
            }
        }).catch((e) => {
            if (e.response) {
                setSubmitting(false);
                dispatch(ScheduleJobFailure(e.response.data.message));
                setMessageHandler({
                    hasMessage: true,
                    type: 'error',
                    message: e.response.data.message,
                });
            }
            else {
                setSubmitting(false);
                dispatch(ScheduleJobFailure(e.message));
                setMessageHandler({
                    hasMessage: true,
                    type: 'error',
                    message: e.message,
                });
            }
        })
    }
}

export const ScheduleJobUpdateRequest = (id: string, body: ScheduleJob, setMessageHandler: any):
    ThunkAction<Promise<void>, {}, {}, supplierAction> => {
    setMessageHandler({
        hasMessage: false,
        type: '',
        message: '',
    });
    return (dispatch: ThunkDispatch<{}, {}, supplierAction>) => {
        return AXIOS.put(`${Prefix.api}/admin/schedule/job/update/${id}`, body, { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const supplier: Supplier = data.result;
                dispatch(ScheduleJobUpdateSuccess(supplier))
                setMessageHandler({
                    hasMessage: true,
                    type: 'success',
                    message: data.message,
                });
            }
        }).catch((e) => {
            if (e.response) {
                dispatch(ScheduleJobFailure(e.response.data.message));
                setMessageHandler({
                    hasMessage: true,
                    type: 'error',
                    message: e.response.data.message,
                });
            }
            else {
                dispatch(ScheduleJobFailure(e.message));
                setMessageHandler({
                    hasMessage: true,
                    type: 'error',
                    message: e.message,
                });
            }
        })
    }
}

export const ScheduleJobDeleteRequest = (id: string, body: ScheduleJob, setMessageHandler: any):
    ThunkAction<Promise<void>, {}, {}, supplierAction> => {
    setMessageHandler({
        hasMessage: false,
        type: '',
        message: '',
    });
    return (dispatch: ThunkDispatch<{}, {}, supplierAction>) => {
        return AXIOS.put(`${Prefix.api}/admin/schedule/job/update/${id}`, body, { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const supplier: Supplier = data.result;
                dispatch(ScheduleJobDeleteSuccess(supplier))
                setMessageHandler({
                    hasMessage: true,
                    type: 'success',
                    message: data.message,
                });
            }
        }).catch((e) => {
            if (e.response) {
                dispatch(ScheduleJobFailure(e.response.data.message));
                setMessageHandler({
                    hasMessage: true,
                    type: 'error',
                    message: e.response.data.message,
                });
            }
            else {
                dispatch(ScheduleJobFailure(e.message));
                setMessageHandler({
                    hasMessage: true,
                    type: 'error',
                    message: e.message,
                });
            }
        })
    }
}